/* Drag&Drop — delegated variant selection; works after AJAX/load-more inserts cards */
(function () {
  'use strict';
  function getCard(el){return el.closest('.ddnc-card, .ddnn-card');}
  function closePanel(panel){
    if (!panel) return;
    panel.classList.remove('is-open');
    var toggle=panel.querySelector('[data-ddcv-toggle]');
    if (toggle) toggle.setAttribute('aria-expanded','false');
  }
  function applyVariant(button){
    var card=getCard(button);
    if (!card) return;
    var group=button.closest('[data-ddcv]');
    if (!group) return;
    group.querySelectorAll('[data-ddcv-choice]').forEach(function(item){
      var active=item===button;
      item.classList.toggle('is-selected',active);
      item.setAttribute('aria-pressed',active?'true':'false');
    });
    var id=button.getAttribute('data-ddcv-id');
    var url=button.getAttribute('data-ddcv-url');
    var image=button.getAttribute('data-ddcv-image');
    var available=button.getAttribute('data-ddcv-available')==='true';
    if (!id || !url) return;
    card.dataset.variantId=id;
    card.dataset.variantAvailable=String(available);
    var otherProductId=button.getAttribute('data-ddcv-product-id');
    if(otherProductId && !card.dataset.ddcvOriginalProductId) card.dataset.ddcvOriginalProductId=card.dataset.productId||'';
    if(otherProductId) card.dataset.ddcvSiblingActive=otherProductId!==card.dataset.ddcvOriginalProductId?'true':'false';
    if(otherProductId) {
      card.dataset.productId=otherProductId;
      var newHandle=button.getAttribute('data-ddcv-handle');
      if(newHandle) card.dataset.productHandle=newHandle;
      var wishlist=card.querySelector('[data-ddnn-wishlist]');
      if(wishlist) wishlist.setAttribute('aria-pressed','false');
    }
    var newTitle=button.getAttribute('data-ddcv-title');
    if(newTitle) {
      var titleLink=card.querySelector('.ddnc-card__title, .ddnn-card__title');
      if(titleLink) titleLink.textContent=newTitle;
      var imgLink=card.querySelector('.ddnc-card__media-link, .ddnn-card__media-link');
      if(imgLink) imgLink.setAttribute('aria-label',newTitle);
      var priceLink=card.querySelector('.ddnc-card__price-link, .ddnn-card__price-link');
      if(priceLink) priceLink.setAttribute('aria-label',newTitle+' fiyatı');
    }
    card.querySelectorAll('.ddnc-card__media-link, .ddnc-card__title, .ddnc-card__price-link, .ddnn-card__media-link, .ddnn-card__title, .ddnn-card__price-link').forEach(function(a){a.setAttribute('href',url);});
    var img=card.querySelector('.ddnc-card__image, .ddnn-card__primary');
    if (img && image) {
      img.removeAttribute('srcset');
      img.setAttribute('src',image);
      img.setAttribute('alt', (card.querySelector('.ddnc-card__title, .ddnn-card__title')?.textContent || '')+' — '+(button.getAttribute('data-ddcv-value')||''));
    }
    var price=Number(button.getAttribute('data-ddcv-price')||0);
    var compare=Number(button.getAttribute('data-ddcv-compare')||0);
    var priceBox=card.querySelector('.ddnc-card__price, .ddnn-card__price');
    if (priceBox) {
      var current=document.createElement('span');
      current.textContent=button.getAttribute('data-ddcv-price-text')||'';
      current.setAttribute('data-dd-money-cents',String(price));
      priceBox.replaceChildren(current);
      if (compare>price && price>0) {
        var former=document.createElement('s');
        former.textContent=button.getAttribute('data-ddcv-compare-text')||'';
        former.setAttribute('data-dd-money-cents',String(compare));
        priceBox.appendChild(former);
      }
      priceBox.classList.toggle('is-sale',compare>price && price>0);
    }
    var addInput=card.querySelector('[data-ddnn-quick-add] input[name="id"]');
    if (addInput) addInput.value=id;
    var buyButton=card.querySelector('[data-ddnn-quick-add] button[type="submit"]');
    if (buyButton) {buyButton.disabled=!available;buyButton.setAttribute('aria-label',available?'Sepete ekle':'Tükendi');}
    var stock=card.querySelector('.ddnc-card__stock, .ddnn-card__stock');
    if (stock) {
      stock.classList.toggle('is-sold-out',!available);
      var label=stock.querySelector('span:last-child');
      if (label) label.textContent=button.getAttribute('data-ddcv-stock')||(available?'Stokta':'Tükendi');
    }
  }
  // For related separate products, handle the selected product's wishlist ID
  // instead of the original card ID captured by legacy card scripts.
  document.addEventListener('click',function(event){
    var heart=event.target.closest('[data-ddnn-wishlist]');
    if(!heart) return;
    var card=getCard(heart);
    if(!card || card.dataset.ddcvSiblingActive!=='true') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    var id=String(card.dataset.productId||'');
    if(!id)return;
    var list=[];
    try{list=JSON.parse(localStorage.getItem('dd_wishlist_product_ids')||'[]');if(!Array.isArray(list))list=[];}catch(_e){}
    var index=list.indexOf(id);
    if(index<0)list.push(id); else list.splice(index,1);
    try{localStorage.setItem('dd_wishlist_product_ids',JSON.stringify(list));}catch(_e){}
    heart.classList.toggle('is-active',index<0);
    heart.setAttribute('aria-pressed',String(index<0));
  },true);
  document.addEventListener('click',function(event){
    var choice=event.target.closest('[data-ddcv-choice]');
    if (choice) {
      event.preventDefault();
      event.stopPropagation();
      // Apply the chosen variant before dismissing the popover.
      applyVariant(choice);
      document.querySelectorAll('.ddcv.is-open').forEach(closePanel);
      // Prevent a focused choice from visually retaining the panel.
      if (typeof choice.blur === 'function') choice.blur();
      return;
    }
    var toggle=event.target.closest('[data-ddcv-toggle]');
    if (toggle) {
      event.preventDefault();
      event.stopPropagation();
      var panel=toggle.closest('[data-ddcv]');
      var open=!panel.classList.contains('is-open');
      document.querySelectorAll('.ddcv.is-open').forEach(closePanel);
      panel.classList.toggle('is-open',open);
      toggle.setAttribute('aria-expanded',String(open));
      return;
    }
    if (!event.target.closest('[data-ddcv]')) document.querySelectorAll('.ddcv.is-open').forEach(closePanel);
  });
  // Delegated pointer exit works for cards injected by filters or load-more.
  // Moving between a thumbnail and another element inside the same panel is safe.
  document.addEventListener('pointerout',function(event){
    if (event.pointerType && event.pointerType!=='mouse' && event.pointerType!=='pen') return;
    var group=event.target.closest('[data-ddcv]');
    if (!group || !group.classList.contains('is-open')) return;
    if (event.relatedTarget && group.contains(event.relatedTarget)) return;
    closePanel(group);
  },true);
  // Keyboard navigation out of the current panel also dismisses it.
  document.addEventListener('focusin',function(event){
    var active=event.target.closest('[data-ddcv]');
    document.querySelectorAll('.ddcv.is-open').forEach(function(group){
      if (group!==active) closePanel(group);
    });
  });
  document.addEventListener('keydown',function(event){
    if (event.key==='Escape') document.querySelectorAll('.ddcv.is-open').forEach(closePanel);
  });
})();
